import { render, staticRenderFns } from "./ReserveRecommend.vue?vue&type=template&id=735c2178&scoped=true"
import script from "./ReserveRecommend.vue?vue&type=script&lang=js"
export * from "./ReserveRecommend.vue?vue&type=script&lang=js"
import style0 from "./ReserveRecommend.vue?vue&type=style&index=0&id=735c2178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735c2178",
  null
  
)

export default component.exports